export const advancedExamples = {
  DISEASES: {
    name: [
      'hypertension',
      'hepatocarcinoma',
      'breast cancer',
      'hypercholesterolemia',
      'alzheimer',
      'diabetes',
      'depression',
    ],
    diseaseUMLSCUI: [
      'C0002736',
      'C1862939',
      'C2677565',
      'C2675491',
      'C3150692',
      'C3151403',
      'C3275459',
      'C3280587',
      'C3553719',
      'C3715155',
      'C1859807',
      'C3715156',
      'C3807521',
      'C4015512',
      'C4693381',
      'C5436882',
      'C5830359',
      'C5830642',
      'C1865409',
      'C1865864',
      'C2750729',
      'C1837728',
      'C2678468',
      'C4302169',
      'C0393554',
      'C1862940',
      'C4551993',
      'C0543859',
      'C1862941',
      'C4016314',
      'C3149907',
      'C4693523',
      'C4693609',
      'C2931786',
      'C4024604',
      'C1834304',
      'C1865384',
      'C5568978',
      'C5686324',
      'C0393552',
      'C4522181',
      'C0221759',
      'C1839259',
      'C0007286',
      'C5704675',
      'C1839566',
      'C0271685',
      'C1848736',
    ],
    MSH: [
      'D014211',
      'D003922',
      'D003923',
      'D009369',
      'D002283',
      'D000544',
      'D003920',
      'D006973',
      'D010300',
      'D001249',
      'D009765',
      'D007676',
    ],
    OMIM: [
      '147450',
      '612069',
      '602432',
      '606352',
      '137070',
      '105400',
      '104300',
      '222100',
      '145900',
      '168600',
      '101600',
      '601806',
      '609441',
      '609529',
      '602544',
    ],
    NCI: [
      'C34373',
      'C34558',
      'C131626',
      'C131687',
      'C132826',
      'C153387',
      'C129806',
      'C34379',
      'C34381',
      'C34372',
      'C34375',
      'C34382',
      'C34383',
    ],
    EFO: [
      '0001357',
      '0000474',
      '0000180',
      '0000231',
      '0000400',
      '0000540',
      '0003767',
      '0000621',
      '0001071',
      '0000616',
      '0001645',
    ],
    DO: [
      '0060193',
      '0060196',
      '0060197',
      '0060198',
      '0060199',
      '0060200',
      '0060201',
      '0060202',
      '0060203',
      '0060204',
      '0060205',
    ],
    ORDO: [
      '88673',
      '918',
      '234567',
      '345678',
      '456789',
      '567890',
      '678901',
      '789012',
      '890123',
      '901234',
      '112345',
      '223456',
      '334567',
      '445678',
      '556789',
      '667890',
      '778901',
      '889012',
      '990123',
      '101234',
      '112345',
      '123456',
      '134567',
      '145678',
      '156789',
      '167890',
      '178901',
      '189012',
      '290123',
      '301234',
      '312345',
      '323456',
      '434567',
      '545678',
      '656789',
      '767890',
      '878901',
      '989012',
      '990234',
      '100123',
      '110234',
      '120345',
      '130456',
      '140567',
      '150678',
      '160789',
      '170890',
      '180901',
      '190012',
      '200123',
      '210234',
      '220345',
      '230456',
      '240567',
      '250678',
      '260789',
      '270890',
      '280901',
      '290012',
      '300123',
      '310234',
      '320345',
      '330456',
      '340567',
      '350678',
      '360789',
      '370890',
      '380901',
      '390012',
      '400123',
      '410234',
      '420345',
      '430456',
      '440567',
      '450678',
      '460789',
      '470890',
      '480901',
      '490012',
      '500123',
      '510234',
      '520345',
      '530456',
      '540567',
      '550678',
      '560789',
      '570890',
      '580901',
      '590012',
      '600123',
      '610234',
      '620345',
      '630456',
      '640567',
      '650678',
      '660789',
      '670890',
      '680901',
      '690012',
      '700123',
      '710234',
      '720345',
      '730456',
      '740567',
      '750678',
      '760789',
      '770890',
      '780901',
      '790012',
      '800123',
      '810234',
      '820345',
    ],
    HPO: [
      'HP:0009031',
      'HP:0001250',
      'HP:0004322',
      'HP:0001943',
      'HP:0001658',
      'HP:0002376',
      'HP:0000238',
      'HP:0001290',
      'HP:0001871',
      'HP:0004328',
    ],
    MONDO: [
      '0005335',
      '0008315',
      '0004950',
      '0005159',
      '0008315',
      '0005138',
      '0004989',
      '0007254',
      '0007256',
      '0005335',
      '0007103',
      '0007108',
      '0007109',
      '0007110',
      '0007113',
      '0007114',
    ],
  },
  VARIANTS: {
    strID: [
      'rs75290158',
      'rs142200609',
      'rs893051',
      'rs2228145',
      'rs12720356',
      'rs11385942',
      'rs1799853',
      'rs2236225',
      'rs6754875',
      'rs7138803',
      'rs4994',
      'rs17782313',
      'rs1421085',
      'rs8050136',
      'rs1044498',
      'rs2229616',
      'rs17817449',
      'rs13447331',
      'rs6548238',
      'rs1558902',
      'rs10938397',
      'rs1121980',
      'rs7498665',
      'rs52820871',
      'rs13447329',
      'rs1800571',
      'rs34911341',
      'rs397832689',
      'rs987237',
      'rs1805081',
      'rs7754561',
      'rs79783591',
      'rs1800437',
      'rs6567160',
      'rs121909065',
      'rs10968576',
      'rs7132908',
      'rs12463617',
      'rs2605100',
      'rs7754840',
      'rs4684677',
      'rs942758928',
      'rs9941349',
      'rs1057517991',
      'rs988712',
      'rs121913561',
      'rs121913563',
      'rs747681609',
      'rs52804924',
      'rs187152753',
    ],
    chromocoord: [
      '1:11796321',
      '6:31575254',
      '7:140753336',
      '7:140753335',
      '7:22727026',
      '1:11794419',
      '7:150999023',
      '11:27658369',
      '22:19963748',
      '1:206773552',
    ],
    proteinStrID: [
      'GJB2 Val153Ile',
      'GJB2 Arg127His',
      'USH2A Gly3529Cys',
      'MYO7A Arg1553Gln',
      'GJB2 Leu76Pro',
      'GJB2 V153F',
      'USH2A P2811S',
      'GJB2 R127C',
    ],
  },
  GENES: {
    symbol: [
      'SCN1A',
      'SCN2A',
      'TBCD',
      'TCF7L2',
      'NAA15',
      'JARID2',
      'CREBBP',
      'CTNNB1',
      'ASXL1',
      'SIN3A',
      'FOXP1',
      'CDK8',
      'BCKDK',
      'NSD1',
      'WDR26',
      'SHANK3',
      'CDK13',
      'BRSK2',
      'MARK2',
      'MYT1L',
      'NEXMIF',
      'SETD5',
      'CHD8',
      'ZSWIM6',
      'ZNF292',
      'IQSEC2',
      'POGZ',
      'ANKRD17',
      'TANC2',
      'LRP2',
      'PHF21A',
      'WAC',
      'QRICH1',
      'PRR12',
      'CLCN2',
      'DDX3X',
      'NALCN',
      'ANKRD11',
      'CTCF', 
      'CHD2',
      'TCF4',
      'TCF20',
      'MBOAT7',
      'TRIP12',
      'ZEB2',
      'SOX6',
      'ADNP',
    ],
    name: [
      'Chromosome 9 Open Reading Frame 72',
      'tumor necrosis factor',
      'hemoglobin subunit beta',
      'C-reactive protein',
      'estrogen receptor 1',
      'interleukin 6',
      'apolipoprotein E',
      'NRF2',
      'Beclin-1',
    ],
    geneID: ['672', '7157', '1956', '8174', '7098', '7428', '5925', '1080', '675'],
    uniprotID: [
      'P04637',
      'Q9BYF1',
      'P38398',
      'Q16539',
      'P38398',
      'P35222',
      'P00533',
      'Q6P6B7',
      'P01106',
      'Q16850',
    ],
    ensemblID: [
      'ENSG00000141510',
      'ENSG00000134982',
      'ENSG00000157764',
      'ENSG00000197386',
      'ENSG00000148795',
      'ENSG00000169083',
      'ENSG00000164327',
      'ENSG00000196367',
    ],
  },
  CHEMICALS: {
    CHEBI: ['16236', '18243', '42639', '28748', '63618', '27732'], //'18258', cambia numero a 533015
    DRUGBANK: ['DB00002', 'DB00898', 'DB00997', 'DB00175', 'DB00201', 'DB00501', 'DB00762'],
    MESH: ['D002945', 'D000431', 'D000077146', 'D017035', 'D002110', 'D002927', 'D004317'],
    CHEMBL: ['CHEMBL545', 'CHEMBL53463', 'CHEMBL481', 'CHEMBL30', 'CHEMBL113', 'CHEMBL1144'],
    PUBCHEM: ['702', '2244', '323', '8058', '807', '6212'],
    name: ['Prozac', 'Tylenol', 'aspirin', 'Lipitor', 'Valium', 'xanax', 'Norvasc', 'TMZ', 'Fluorouracil'],
  },
};
